import { angularServicesNames } from "./angularServicesNames";

export class ToasterService {
    static componentName = "toasterService";
    static $inject = ["toastr", angularServicesNames.$translate, "AlertService"];

    constructor(
        private toastr: ng.toastr.IToastrService,
        private $translate: ng.translate.ITranslateService,
        private alertService: AlertService
    ) {}

    showReportGeneratingToast(title: string): ng.toastr.IToast {
        return this.toastr.info(
            '<div class="cg-busy-default-spinner"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div>' +
                '<div class="bar4"></div><div class="bar5"></div><div class="bar6"></div><div class="bar7"></div>' +
                '<div class="bar8"></div><div class="bar9"></div><div class="bar10"></div><div class="bar11"></div>' +
                '<div class="bar12"></div></div>',
            '<span class="margin-left-30">' + this.$translate.instant(title) + "</span>",
            {
                allowHtml: true,
                autoDismiss: false,
                closeButton: false,
                closeHtml: "",
                tapToDismiss: false,
                timeOut: 0,
                extendedTimeOut: 0
            } as any
        );
    }

    showReportGenerateBusyIndicator(
        func: () => ng.IPromise<any>,
        generatingTitle: string,
        generatedTitle: string
    ): void {
        const toast = this.showReportGeneratingToast(generatingTitle);
        func().then(
            () => {
                this.toastr.clear(toast);
                this.alertService.success(this.$translate.instant(generatedTitle));
            },
            () => this.toastr.clear(toast)
        );
    }

    warning(translateKey: string): void {
        this.alertService.warning(this.$translate.instant(translateKey));
    }

    success(translateKey: string): void {
        this.alertService.success(this.$translate.instant(translateKey));
    }

    error(translateKey: string): void {
        this.alertService.error(this.$translate.instant(translateKey));
    }

    info(translateKey: string): void {
        this.alertService.info(this.$translate.instant(translateKey));
    }

    clear(toast: ng.toastr.IToast): void {
        this.toastr.clear(toast);
    }
}

angular.module("topline.app").service(ToasterService.componentName, ToasterService);
